class RyvexProductCard extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.unitPrice = parseFloat(this.dataset.unitPrice) || 0;
    this.currencySymbol = this.dataset.currencySymbol || '$';
    this.available = this.dataset.available === 'true';

    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.decreaseButton = this.querySelector('[data-action="decrease"]');
    this.increaseButton = this.querySelector('[data-action="increase"]');
    this.sellingPlanInput = this.querySelector('[data-ryvex-selling-plan-input]');
    this.frequencySelect = this.querySelector('[data-role="frequency-select"]');
    this.radios = Array.from(this.querySelectorAll('[data-role="purchase-radio"]'));
    this.labelEl = this.querySelector('[data-role="submit-label"]');
    this.totalEl = this.querySelector('[data-role="submit-total"]');
    this.optionEls = {
      subscribe: this.querySelector('[data-option="subscribe"]'),
      'one-time': this.querySelector('[data-option="one-time"]'),
    };

    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('.ryvex-product-card__submit');

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.update());
    });
    this.frequencySelect?.addEventListener('change', () => this.update());
    this.quantityInput?.addEventListener('input', () => this.update());
    this.quantityInput?.addEventListener('change', () => this.update());

    this.decreaseButton?.addEventListener('click', () => this.stepQuantity(-1));
    this.increaseButton?.addEventListener('click', () => this.stepQuantity(1));

    this.form?.addEventListener('submit', () => this.setLoading(true));
    this.addEventListener('cart:update', () => this.setLoading(false));
    this.addEventListener('cart:error', () => this.setLoading(false));

    this.productUrl = this.dataset.productUrl;
    this.style.cursor = this.productUrl ? 'pointer' : '';
    this.addEventListener('click', (event) => this.handleCardClick(event));

    this.update();
  }

  handleCardClick(event) {
    if (!this.productUrl) return;
    if (event.target.closest('a, button, input, select, label')) return;
    window.location.href = this.productUrl;
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;
    if (isLoading) {
      this.submitButton.dataset.loading = 'true';
    } else {
      delete this.submitButton.dataset.loading;
    }
  }

  stepQuantity(delta) {
    if (!this.quantityInput) return;
    const min = parseInt(this.quantityInput.min, 10) || 1;
    const max = parseInt(this.quantityInput.max, 10) || 99;
    const current = parseInt(this.quantityInput.value, 10) || min;
    this.quantityInput.value = Math.min(max, Math.max(min, current + delta));
    this.update();
  }

  get purchaseType() {
    const checked = this.radios.find((radio) => radio.checked);
    return checked ? checked.value : 'one-time';
  }

  update() {
    const quantity = parseInt(this.quantityInput?.value, 10) || 1;
    const type = this.purchaseType;

    Object.entries(this.optionEls).forEach(([key, el]) => {
      el?.classList.toggle('is-selected', key === type);
    });

    if (this.frequencySelect) {
      this.frequencySelect.hidden = type !== 'subscribe';
    }

    let unitPrice = this.unitPrice;
    let label = 'Add to Cart';

    if (type === 'subscribe' && this.frequencySelect) {
      const selectedOption = this.frequencySelect.selectedOptions[0];
      unitPrice = parseFloat(selectedOption?.dataset.price) || this.unitPrice;
      const frequencyText = (selectedOption?.textContent || '').trim();
      const frequencyNumber = frequencyText.match(/\d+/)?.[0];
      label = frequencyNumber ? `Subscribe · ${frequencyNumber}D` : frequencyText ? `Subscribe · ${frequencyText}` : 'Subscribe';

      if (this.sellingPlanInput) {
        this.sellingPlanInput.disabled = false;
        this.sellingPlanInput.value = this.frequencySelect.value;
      }
    } else if (this.sellingPlanInput) {
      this.sellingPlanInput.disabled = true;
    }

    if (!this.available) return;

    if (this.labelEl) {
      this.labelEl.textContent = label;
    }
    if (this.totalEl) {
      this.totalEl.textContent = `${this.currencySymbol}${(unitPrice * quantity).toFixed(2)}`;
    }
  }
}

if (!customElements.get('ryvex-product-card')) {
  customElements.define('ryvex-product-card', RyvexProductCard);
}
